import React, { Component } from 'react'
import CheckoutFrame from '../components/CheckoutFrame'
import Button from '../../../components/common/Button'
import { LeftOutlined } from '@ant-design/icons'
import { NoMembershipDescription } from '../components/description-components'
import styles from './no-memebership.scss'
import PropTypes from 'prop-types'

export class NoMembership extends Component {
  render() {
    return <CheckoutFrame
      left={<main className={styles['main-container']}>
        <header><h1>No Membership</h1></header>
        <section>
          <p>For hosts who don’t mind spending the time to send invites individually from your own number</p>
        </section>
        <section>
          <Button
            onClick={() => {
              this.props.goToCheckoutNode(this.props.previousNode)
            }}
            className={styles['go-back-btn']}><LeftOutlined />&nbsp;BACK</Button>
        </section>
      </main>}
      right={NoMembershipDescription()}
    />
  }
}

NoMembership.propTypes = {
  goToCheckoutNode: PropTypes.func,
  previousNode: PropTypes.string
}
